import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { renderElementSpecialObjectVoid } from './renderElementSpecialObjectVoid';
import { SPECIAL_OBJECT_VOID } from './types';

export const SpecialObjectPlugin = (options?: any): SlatePlugin => ({
  renderElement: renderElementSpecialObjectVoid(options),
  voidTypes: [SPECIAL_OBJECT_VOID],
});
